export default __webpack_public_path__ + "static/media/linkedin.cc1494dd.png";